// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";
import AvatarWithName from "@/components/AvatarWithName";
import Button from "@/components/Button";
import { urlRegex } from "@/constants/common-constant";
import { MEEY_REVIEW_API_URL } from "@/constants/environment";
import { fileType } from "@/constants/file";
import { DEFAULT_IMAGE_CARD } from "@/constants/image";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";

import { IReviewItem } from "Models";
import { Form, Input, notification } from "antd";
import axios from "axios";
import { useContext, useRef } from "react";
// import UploadReviewFile from "@/components/ReviewInputComponent.tsx/UploadReviewFile";
import { MediaTypeEnum } from "@/constants/enum/media";
import InputReplyReview from "./InputReplyReview";

const FormReplyReview = ({
  data,
  reviewItem,
  reviewIndex,
}: // onCancelReview,
{
  data: IReviewItem;
  reviewItem: IReviewItem;
  onCancelReview?: () => void;
  reviewIndex?: number;
}) => {
  const [form] = Form.useForm();

  const {
    setCurrentShowFormReply,
    handleSyncNumberReview,
    listReviewsIds,
    loadingSendReply,
    setLoadingSendReply,
    setListReviewIds,
  } = useContext(ProjectContext);

  const formRef = useRef<HTMLDivElement>(null);
  const { user, userDataHeader } = useAuth();
  const {
    setProjectListVote,
    currentRefItem,
    projectListVote,
    reviewDetail,
    setReviewDetail,
  } = useContext(ProjectContext);
  const timeOutBachground = useRef<NodeJS.Timeout>(null);
  return (
    <>
      <div className="mt-2 flex gap-3 items-start" ref={formRef}>
        <AvatarWithName
          imageClass="md:!w-10 md:!h-10 !w-8 !h-8"
          imageProps={{ resizeOnFly: false }}
          className="flex-0 "
          avatarOnly
          alt={user?.name ?? "Ẩn danh"}
          name={user?.name}
          src={
            user?.avatar ? user?.avatar : user?.name ? null : DEFAULT_IMAGE_CARD
          }
        />
        <div className="flex-1 overflow-auto">
          <Form
            form={form}
            initialValues={{
              nickName: "",
              comment: "",
            }}
            onFinish={async (value) => {
              setLoadingSendReply(true);
              try {
                const mediaFile =
                  value?.file && value?.file?.length
                    ? value?.file?.map((item) => {
                        if (item.name.match(fileType.file)) {
                          return {
                            type: MediaTypeEnum.FILE,
                            s3Keys: [item.s3Key],
                          };
                        }
                        if (item.name.match(fileType.image)) {
                          return {
                            type: MediaTypeEnum.IMAGE,
                            s3Keys: [item.s3Key],
                          };
                        }
                        if (item.name.match(fileType.video)) {
                          return {
                            type: MediaTypeEnum.VIDEO,
                            s3Keys: [item.s3Key],
                          };
                        }
                      })
                    : [];
                const res = await axios.request({
                  method: "post",
                  baseURL: MEEY_REVIEW_API_URL,
                  url: "v1/comments/" + reviewItem._id + "/reply",
                  headers: {
                    ...userDataHeader,
                  },
                  data: {
                    nickName: `${value.nickName ?? ""}`,
                    comment: value.comment?.trim(),
                    links: value.comment.match(urlRegex) || [],

                    mentions: value.comment.includes(
                      `@{{${data.createdBy._id}||${
                        data.nickName ? data.nickName : "anymos"
                      }}}`
                    )
                      ? [
                          {
                            userId: data.createdBy._id,
                            nickName: data.nickName || "",
                          },
                        ]
                      : [],
                    media: mediaFile,
                  },
                });
                // thêm id của reply mới vào listReviewIds
                setListReviewIds([...listReviewsIds, res?.data?._id]);

                setProjectListVote({
                  ...projectListVote,
                  results: projectListVote.results.map((review) => {
                    if (review._id === reviewItem._id)
                      return {
                        ...review,
                        replies: [...review.replies, res.data],
                        totalReply: review.totalReply + 1,
                      };
                    else return review;
                  }),
                });

                setCurrentShowFormReply(null);

                // chi tiết review
                if (res && reviewDetail) {
                  setReviewDetail(
                    reviewDetail.map((item) => {
                      return {
                        ...item,
                        replies: [...item.replies, res.data],
                      };
                    })
                  );
                }

                await handleSyncNumberReview();
                setTimeout(() => {
                  if (currentRefItem.current[reviewIndex]) {
                    window.scrollTo({
                      behavior: "smooth",
                      top:
                        currentRefItem.current[reviewIndex].offsetTop +
                        currentRefItem.current[reviewIndex].clientHeight -
                        window.innerHeight,
                    });

                    const lastedRepltItenm = currentRefItem.current[reviewIndex]
                      .getElementsByClassName("reply-review-list")
                      ?.item(0)?.lastChild as HTMLDivElement;
                    if (lastedRepltItenm) {
                      lastedRepltItenm.style.background = "#EBF3FC";
                      if (timeOutBachground)
                        clearTimeout(timeOutBachground.current);
                      timeOutBachground.current = setTimeout(() => {
                        lastedRepltItenm.style.background = "white";
                      }, 2000);
                    }
                  }
                }, 0);
              } catch (error) {
                if (error?.response?.data?.code === 400) {
                  form.setFields([
                    {
                      name: "comment",
                      errors: [error?.response?.data?.message],
                    },
                  ]);
                } else
                  notification.error({
                    message: "Có lỗi xảy ra, vui lòng thử lại sau",
                    style: {
                      width: "100%",
                      top: 56,
                    },
                  });
              } finally {
                setTimeout(() => {
                  setLoadingSendReply(false);
                }, 0);
              }
            }}>
            <Form.Item name={"nickName"} className="mb-2">
              <Input
                // ref={inputRef}
                placeholder="Nick name của bạn"
                size="large"
                maxLength={50}
                disabled={loadingSendReply}
              />
            </Form.Item>
            <InputReplyReview data={data} reviewItem={reviewItem} />
            <div className="flex justify-end gap-2 mt-2">
              <Button
                btnType="link"
                color="grey"
                disabled={loadingSendReply}
                onClick={() => {
                  setCurrentShowFormReply(null);
                }}>
                Hủy
              </Button>
              <Form.Item noStyle shouldUpdate>
                {({ getFieldsError, isFieldTouched, getFieldValue }) => {
                  return (
                    <Button
                      btnType="filled"
                      type="button"
                      onClick={form.submit}
                      className="!px-3"
                      loading={loadingSendReply}
                      disabled={
                        loadingSendReply ||
                        (!getFieldValue(["comment"])?.trim() &&
                          !getFieldValue(["file"])?.length) ||
                        getFieldsError().some(({ errors }) => errors.length)
                      }>
                      Đăng phản hồi
                    </Button>
                  );
                }}
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default FormReplyReview;
